import { Users } from "lucide-react";
import { formatUserName, Person } from "@forgepoint/shared";

/**
 * Displays the associated people with an icon for the read-only opportunity detail view.
 * Renders nothing when no people are associated.
 * @param people - The associated people, read directly from the hydrated opportunity
 * @returns The people display row, or null when there are no people
 */
export function PeopleDisplay({ people }: { people: Person[] | undefined }) {
  if (!people || people.length === 0) {
    return null;
  }

  const names = people.map((person) =>
    formatUserName(
      person.firstName,
      person.lastName,
      person.email || "Unknown",
    ),
  );

  return (
    <div className="flex items-center gap-1.5 mt-1 mb-3">
      <Users className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
      <span className="text-[11px] font-medium uppercase tracking-wide leading-none text-muted-foreground/70">
        People
      </span>
      <p className="text-sm text-muted-foreground">{names.join(", ")}</p>
    </div>
  );
}
